export default __webpack_public_path__ + "static/media/ta.51160615.mp3";